import React from 'react'
import TabsForm, { TabsFormDataContext } from './components/TabsForm'
import { ModelListPage, ModelFormPage, ModelDetailPage } from './components/Pages'
import BooleanIcon from './components/BooleanIcon'
import ItemEditForm from './components/ItemEditForm'
import { ModelListPage as ExtModelListPage, ModelFormPage as ExtModelFormPage, ExtendsModel } from './components/ExtendsPage'
import BatchDelete from './components/BatchDelete'
import { ActionModalEdit, ActionModalView } from './components/ItemActions'
import DataDetail from './components/DataDetail'
import ModelListSubMenu from './components/ModelListSubMenu'

export default {
  components: {
    'Model.ListPage': ModelListPage,
    'Model.FormPage': ModelFormPage,
    'Model.DetailPage': ModelDetailPage,
    'Model.TabsForm': TabsForm,
    'Model.ExtendListPage': ExtModelListPage,
    'Model.ExtendFormPage': ExtModelFormPage,
    'Model.ItemEditForm': ItemEditForm,
    'Model.BooleanIcon': BooleanIcon,
    'Model.ExtendsModel': ExtendsModel,
    'Model.BatchDelete': BatchDelete,
    'Model.DataDetail': DataDetail,
    'Model.ActionModalEdit': ActionModalEdit,
    'Model.ActionModalView': ActionModalView,
    'Model.ListSubMenu': ModelListSubMenu
  }
}
